const isElement = selector => document.querySelector(selector) !== null;

export default isElement;



// WEBPACK FOOTER //
// ./app/scripts/util/isElement.js